var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtraincome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#ebedef;}.c,.d{fill:#9c3;}.d{stroke:#fafafa;stroke-width:0.5px;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-225 -1690)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(225 1690)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 89
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163 4.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11.667,
    height: 16.154,
    transform: "translate(399.795 1744.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398 1695)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.618,336.091a5.918,5.918,0,0,0-7.213-1.583l-13.366,6.565v-.713a6.861,6.861,0,0,0-6.806-6.9H24.312a1.4,1.4,0,0,0-.847.284l-6.225,4.714v-2.392a1.4,1.4,0,0,0-1.4-1.4H3.4a1.4,1.4,0,0,0-1.4,1.4v17.212a1.4,1.4,0,0,0,1.4,1.4H15.838a1.4,1.4,0,0,0,1.4-1.4v-1.638l21.191,5.98a7.437,7.437,0,0,0,5.324-.407L68.52,345.469a6,6,0,0,0,3.324-4.143A6.076,6.076,0,0,0,70.618,336.091ZM14.436,351.877H4.8V337.469h9.631ZM69.11,340.7a3.222,3.222,0,0,1-1.784,2.228L42.553,354.68a4.639,4.639,0,0,1-3.327.252l-.023-.007-21.963-6.2v-6.75l7.543-5.712h18.45a4.054,4.054,0,0,1,4,4.1v1.562h-10a1.4,1.4,0,0,0,0,2.8H48.644a1.4,1.4,0,0,0,.636-.156l15.361-7.545a3.126,3.126,0,0,1,3.807.843A3.29,3.29,0,0,1,69.11,340.7Z",
    transform: "translate(-2 -287.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.8,47.064a21.518,21.518,0,1,0-21.518-21.518A21.543,21.543,0,0,0,185.8,47.064Zm0-40.232a18.714,18.714,0,1,1-18.714,18.714A18.735,18.735,0,0,1,185.8,6.831Z",
    transform: "translate(-143.041 -4.027)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11.537-11.879H9.08a4.937,4.937,0,0,1,.705,1.964h2.363L11.525-7.6H9.773A4.611,4.611,0,0,1,8.374-4.8a6.559,6.559,0,0,1-3.245,1.45l5.138,6.091V2.9H6.375L.685-3.768.673-5.847H3.459A2.522,2.522,0,0,0,6.187-7.6H.391L1-9.915H6.117a2.459,2.459,0,0,0-2.528-1.446H.391l.694-2.857H12.148Z",
    transform: "translate(36.404 27.681)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraincome);
export default __webpack_public_path__ + "static/media/extraincome.5e6da0b4be4575896da2e8943dc5ccbe.svg";
export { ForwardRef as ReactComponent };